import api from '@pray/shared/utils/api';
import type { ListResponse } from '@pray/shared/utils/api/types/response';

import type { StreakSessionResponse } from './types';

export async function getMemberStreakSessions(memberId: string, month: string) {
  const url = `/web/studio/users/${memberId}/streaks/sessions`;

  const response = await api.executeGetRequest<ListResponse<StreakSessionResponse>>(url, { month });

  return response.data;
}
